// Firebase knows if the user is logged in or not, but App gets drawn before Firebase gets called,
// so we need a temporary third state "unknown"
const LoggedInStatus = {
    unknown: 'unknown',
    loggedIn: 'loggedIn',
    loggedOut: 'loggedOut',
    awaitingEmailVerification: 'awaitingEmailVerification',
}

export { LoggedInStatus }
